import { render, staticRenderFns } from "./TheLogout.vue?vue&type=template&id=a8d7e3c4&"
import script from "./TheLogout.vue?vue&type=script&lang=js&"
export * from "./TheLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports